module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.isVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('div', {
    ref: "print",
    staticClass: "one-page"
  }, [_c('div', {
    staticClass: "mast-head"
  }, [_c('div', {
    staticClass: "colony-logo"
  }, [_c('div', {
    staticClass: "logo-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.colonyLogoB64
    }
  })])]), _vm._v(" "), (_vm.company.logo) ? _c('div', {
    staticClass: "company-logo"
  }, [_c('div', {
    staticClass: "logo-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.companyLogoB64
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', [_c('h1', [_vm._v(_vm._s(_vm.currentTitle))]), _vm._v(" "), (!_vm.isEditingTitle) ? _c('div', {
    staticClass: "monitor pull-right"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Edit title",
      "placement": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.isEditingTitle = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-edit"
  })])], 1)], 1) : _c('div', [_c('el-input', {
    model: {
      value: (_vm.currentTitle),
      callback: function($$v) {
        _vm.currentTitle = $$v
      },
      expression: "currentTitle"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "edit-buttons"
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "danger",
      "size": "mini"
    },
    on: {
      "click": _vm.handleResetTitle
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.handleSaveTitle
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.statData.insight) ? _c('div', {
    staticClass: "insight"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.processedInsight)
    }
  }), _vm._v(" "), (!_vm.isEditingInsight) ? _c('div', {
    staticClass: "monitor pull-right"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Edit insight",
      "placement": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.isEditingInsight = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-edit"
  })])], 1)], 1) : _c('div', [_c('div', {
    staticClass: "monitor"
  }, [_c('span', [_c('el-checkbox', {
    model: {
      value: (_vm.positiveSelections.main),
      callback: function($$v) {
        _vm.$set(_vm.positiveSelections, "main", $$v)
      },
      expression: "positiveSelections.main"
    }
  })], 1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insight),
      expression: "insight"
    }],
    ref: "insightTextArea",
    domProps: {
      "value": (_vm.insight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.insight = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "edit-buttons"
  }, [_c('el-button-group', [_vm._l((_vm.insightVariables), function(item) {
    return _c('el-button', {
      key: item.key,
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.handleAppendInsightVariable('insightTextArea', item.key)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "mini"
    },
    on: {
      "click": _vm.handleResetInsight
    }
  }, [_vm._v("Reset")]), _vm._v(" "), (_vm.isEditingInsight) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.handleSaveInsight
    }
  }, [_vm._v("Save")]) : _vm._e()], 2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "monitor clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "insight-chart"
  }, [(_vm.statData.chart !== 'VERTICAL_BAR_STACKED') ? _c('div', {
    staticClass: "pull-right positive-only monitor"
  }, [_c('strong', {
    staticStyle: {}
  }, [_vm._v("Display only positive")]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.positiveSelections.main),
      callback: function($$v) {
        _vm.$set(_vm.positiveSelections, "main", $$v)
      },
      expression: "positiveSelections.main"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix monitor"
  }), _vm._v(" "), _c('div', [(_vm.statData.chart.length === 0 || _vm.statData.chart === 'VERTICAL_BAR') ? _c('bar-chart', {
    attrs: {
      "height": 200,
      "data": _vm.mainChartTotalDisplay(_vm.statData.answers),
      "printable": _vm.printCharts,
      "tooltipsEnabled": !_vm.printCharts,
      "animationDuration": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.statData.chart === 'HORIZONTAL_BAR') ? _c('horizontal-bar-chart', {
    attrs: {
      "height": 200,
      "data": _vm.mainChartTotalDisplay(_vm.statData.answers),
      "printable": _vm.printCharts,
      "tooltipsEnabled": !_vm.printCharts,
      "animationDuration": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.statData.chart === 'PIE') ? _c('pie-chart', {
    attrs: {
      "height": 200,
      "data": _vm.mainChartTotalDisplay(_vm.statData.answers),
      "printable": _vm.printCharts,
      "tooltipsEnabled": !_vm.printCharts,
      "animationDuration": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.statData.chart === 'DONUT') ? _c('doughnut-chart', {
    attrs: {
      "height": 200,
      "data": _vm.mainChartTotalDisplay(_vm.statData.answers),
      "printable": _vm.printCharts,
      "tooltipsEnabled": !_vm.printCharts,
      "animationDuration": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.statData.chart === 'VERTICAL_BAR_STACKED') ? _c('stacked-bar-chart', {
    attrs: {
      "height": 300,
      "printable": _vm.printCharts,
      "tooltipsEnabled": !_vm.printCharts,
      "animationDuration": 1,
      "showLegend": true,
      "legendPosition": 'bottom',
      "colorCycle": [_vm.generateTitleColor(_vm.statData.question, [260, 290])],
      "data": _vm.stackedTotalDisplay(_vm.statData.answers),
      "options": _vm.stackedChartOptions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.statData.chart === 'WORDCLOUD') ? _c('cloud', {
    attrs: {
      "data": _vm.statData.words || [],
      "fontSizeMapper": _vm.fontSizeMapper,
      "width": 370,
      "height": 300,
      "padding": 5
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.questionLegend && _vm.statData.chart != 'VERTICAL_BAR_STACKED') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('chart-legend', {
    attrs: {
      "titleAlign": 'left',
      "data": _vm.mainChartTotalDisplay(_vm.statData.answers),
      "isPercentage": _vm.selectedTotalDisplay === 'percentage'
    }
  })], 1)]) : (_vm.questionLegend) ? _c('stacked-chart-legend', {
    attrs: {
      "data": _vm.mainChartTotalDisplay(_vm.statData.answers),
      "isPercentage": _vm.selectedTotalDisplay === 'percentage'
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "monitor toggle text-right"
  }, [(_vm.questionLegend) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.questionLegend = false
      }
    }
  }, [_vm._v("[Hide legend]")]) : _vm._e(), _vm._v(" "), (!_vm.questionLegend) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.questionLegend = true
      }
    }
  }, [_vm._v("[Show legend]")]) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "monitor"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Toggle page break",
      "placement": "right"
    }
  }, [_c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.pageBreaks.demographics = !_vm.pageBreaks.demographics
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ellipsis-h"
  })])], 1)], 1), _vm._v(" "), (_vm.pageBreaks.demographics) ? _c('div', {
    staticClass: "page-break"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "monitor clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "monitor pull-right"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Toggle bullet points",
      "placement": "right"
    }
  }, [_c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.handleToggleBulletPoints('demographics')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-circle"
  })])], 1)], 1), _vm._v(" "), (_vm.bulletPointsCollection.hasBulletPoints['demographics']) ? _c('div', {
    staticClass: "bullet-points"
  }, [_c('ul', _vm._l((_vm.bulletPointsCollection.demographics), function(bulletPoint, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "monitor"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_c('el-input', {
      staticClass: "bullet-edit",
      model: {
        value: (_vm.bulletPointsCollection.demographics[index]),
        callback: function($$v) {
          _vm.$set(_vm.bulletPointsCollection.demographics, index, $$v)
        },
        expression: "bulletPointsCollection.demographics[index]"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "print"
    }, [_vm._v(_vm._s(bulletPoint))]), _vm._v(" "), _c('span', {
      staticClass: "monitor"
    }, [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.handleRemoveBulletPoint(index, 'demographics')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-times"
    })])], 1), _vm._v(" "), _c('span', {
      staticClass: "clearfix"
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "monitor"
  }, [_c('el-form', {
    staticClass: "bullet-form",
    attrs: {
      "inline": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticClass: "bullet-edit",
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleAddBulletPoint('demographics')
      }
    },
    model: {
      value: (_vm.newBulletPoint.demographics),
      callback: function($$v) {
        _vm.$set(_vm.newBulletPoint, "demographics", $$v)
      },
      expression: "newBulletPoint.demographics"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddBulletPoint('demographics')
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "demographics row"
  }, _vm._l((_vm.selectedAnalytics), function(selectedAnalytic, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-4"
    }, [_c('div', {
      staticClass: "monitor selector"
    }, [_c('div', [_c('el-select', {
      attrs: {
        "filterable": "",
        "clearable": "",
        "placeholder": "Select one"
      },
      on: {
        "change": function($event) {
          return _vm.handleQuestionChanged(index, selectedAnalytic.key)
        }
      },
      model: {
        value: (selectedAnalytic.key),
        callback: function($$v) {
          _vm.$set(selectedAnalytic, "key", $$v)
        },
        expression: "selectedAnalytic.key"
      }
    }, _vm._l((_vm.selectableAnalytics), function(group) {
      return _c('el-option-group', {
        key: group.label,
        attrs: {
          "label": group.label
        }
      }, _vm._l((group.options), function(item) {
        return _c('el-option', {
          key: ((group.key) + "__" + (item.value)),
          attrs: {
            "label": item.label,
            "value": ((group.key) + "__" + (item.value))
          }
        }, [_c('span', {
          staticStyle: {
            "float": "left"
          }
        }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), (item.type === 'SCALE') ? _c('span', {
          staticStyle: {
            "float": "right"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_c('strong', {
          staticClass: "positive-only-check-box"
        }, [_vm._v("Positive")]), _vm._v(" "), _c('el-checkbox', {
          model: {
            value: (_vm.positiveSelections[index][((group.key) + "__" + (item.value))]),
            callback: function($$v) {
              _vm.$set(_vm.positiveSelections[index], ((group.key) + "__" + (item.value)), $$v)
            },
            expression: "positiveSelections[index][`${group.key}__${item.value}`]"
          }
        })], 1) : _vm._e()])
      }), 1)
    }), 1)], 1), _vm._v(" "), _c('div', [_c('el-select', {
      attrs: {
        "placeholder": "Chart"
      },
      model: {
        value: (selectedAnalytic.chart),
        callback: function($$v) {
          _vm.$set(selectedAnalytic, "chart", $$v)
        },
        expression: "selectedAnalytic.chart"
      }
    }, _vm._l((_vm.selectableCharts), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": item.label,
          "value": item.value
        }
      })
    }), 1)], 1)]), _vm._v(" "), _c('div', {
      staticClass: "chart-title"
    }, [(!_vm.isEditingQuestion[index]) ? _c('h4', [_vm._v("\n            " + _vm._s(_vm.editedQuestions[index] || _vm.selectedTitleDisplay(selectedAnalytic.key)) + "\n          ")]) : _vm._e(), _vm._v(" "), (
      !_vm.isEditingQuestion[index] &&
      (_vm.editedQuestions[index] || _vm.selectedTitleDisplay(selectedAnalytic.key))
    ) ? _c('div', {
      staticClass: "monitor pull-right"
    }, [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.handleEditQuestion(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-edit"
    })])], 1) : _vm._e(), _vm._v(" "), (_vm.isEditingQuestion[index]) ? _c('div', [_c('div', {
      staticClass: "monitor"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editedQuestions[index]),
        expression: "editedQuestions[index]"
      }],
      domProps: {
        "value": (_vm.editedQuestions[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.editedQuestions, index, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "insight-variables"
    }, [_c('el-button-group', [_c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.handleResetQuestion(index, selectedAnalytic.key)
        }
      }
    }, [_vm._v("Reset")]), _vm._v(" "), (_vm.isEditingQuestion[index]) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.handleSaveQuestion(index)
        }
      }
    }, [_vm._v("Save")]) : _vm._e()], 1)], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', [(selectedAnalytic.key) ? _c('div', {
      staticClass: "chart-wrapper"
    }, [(selectedAnalytic.chart === 'horizontal_bar') ? _c('horizontal-bar-chart', {
      attrs: {
        "height": 150,
        "data": _vm.displayKeyData(index, selectedAnalytic.key),
        "printable": _vm.printCharts,
        "tooltipsEnabled": !_vm.printCharts,
        "showYAxes": false,
        "animationDuration": 1
      }
    }) : _vm._e(), _vm._v(" "), (selectedAnalytic.chart === 'vertical_bar') ? _c('bar-chart', {
      attrs: {
        "height": 150,
        "data": _vm.displayKeyData(index, selectedAnalytic.key),
        "printable": _vm.printCharts,
        "tooltipsEnabled": !_vm.printCharts,
        "showXAxes": false,
        "animationDuration": 1
      }
    }) : _vm._e(), _vm._v(" "), (selectedAnalytic.chart === 'pie') ? _c('pie-chart', {
      attrs: {
        "height": 150,
        "data": _vm.displayKeyData(index, selectedAnalytic.key),
        "printable": _vm.printCharts,
        "tooltipsEnabled": !_vm.printCharts,
        "animationDuration": 1
      }
    }) : _vm._e(), _vm._v(" "), (selectedAnalytic.chart === 'donut') ? _c('doughnut-chart', {
      attrs: {
        "height": 150,
        "data": _vm.displayKeyData(index, selectedAnalytic.key),
        "printable": _vm.printCharts,
        "tooltipsEnabled": !_vm.printCharts,
        "animationDuration": 1
      }
    }) : _vm._e(), _vm._v(" "), (selectedAnalytic.chart === 'word_cloud') ? _c('cloud', {
      attrs: {
        "data": _vm.displayWordData(selectedAnalytic.key),
        "fontSizeMapper": _vm.fontSizeMapper,
        "width": 170,
        "height": 350,
        "padding": 5
      }
    }) : _vm._e(), _vm._v(" "), (selectedAnalytic.chart === 'vertical_bar_stacked') ? _c('stacked-bar-chart', {
      attrs: {
        "height": 300,
        "printable": _vm.printCharts,
        "tooltipsEnabled": !_vm.printCharts,
        "animationDuration": 1,
        "showLegend": selectedAnalytic.showLegend,
        "legendPosition": 'bottom',
        "data": _vm.displayKeyData(index, selectedAnalytic.key, selectedAnalytic.chart),
        "options": _vm.stackedChartOptions
      }
    }) : _vm._e(), _vm._v(" "), (
      selectedAnalytic.showLegend && selectedAnalytic.chart != 'vertical_bar_stacked'
    ) ? _c('chart-legend', {
      attrs: {
        "data": _vm.displayKeyData(index, selectedAnalytic.key),
        "isPercentage": _vm.selectedTotalDisplay === 'percentage'
      }
    }) : _vm._e(), _vm._v(" "), (selectedAnalytic.key) ? _c('div', {
      staticClass: "monitor toggle text-right"
    }, [(selectedAnalytic.showLegend) ? _c('a', {
      on: {
        "click": function($event) {
          selectedAnalytic.showLegend = false
        }
      }
    }, [_vm._v("[Hide legend]")]) : _vm._e(), _vm._v(" "), (!selectedAnalytic.showLegend) ? _c('a', {
      on: {
        "click": function($event) {
          selectedAnalytic.showLegend = true
        }
      }
    }, [_vm._v("[Show legend]")]) : _vm._e()]) : _vm._e()], 1) : _vm._e()])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "monitor"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Toggle page break",
      "placement": "right"
    }
  }, [_c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.pageBreaks.sourcing = !_vm.pageBreaks.sourcing
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ellipsis-h"
  })])], 1)], 1), _vm._v(" "), (_vm.pageBreaks.sourcing) ? _c('div', {
    staticClass: "page-break"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "monitor clearfix"
  }), _vm._v(" "), (true) ? _c('div', {
    staticClass: "insight"
  }, [_c('div', [_vm._v(_vm._s(_vm.textBoxContext))]), _vm._v(" "), (!_vm.isEditingTextBox) ? _c('div', {
    staticClass: "monitor pull-right"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Edit text",
      "placement": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.isEditingTextBox = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-edit"
  })])], 1)], 1) : _c('div', [_c('div', {
    staticClass: "monitor"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textBoxContext),
      expression: "textBoxContext"
    }],
    ref: "customTextArea",
    domProps: {
      "value": (_vm.textBoxContext)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textBoxContext = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "edit-buttons"
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "size": "mini"
    },
    on: {
      "click": _vm.handleResetCustomText
    }
  }, [_vm._v("Reset")]), _vm._v(" "), (_vm.isEditingTextBox) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.handleSaveCustomText
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "monitor clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "monitor pull-right"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Toggle bullet points",
      "placement": "right"
    }
  }, [_c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.handleToggleBulletPoints('sourcing')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-circle"
  })])], 1)], 1), _vm._v(" "), (_vm.bulletPointsCollection.hasBulletPoints['sourcing']) ? _c('div', {
    staticClass: "bullet-points"
  }, [_c('ul', _vm._l((_vm.bulletPointsCollection.sourcing), function(bulletPoint, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "monitor"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_c('el-input', {
      staticClass: "bullet-edit",
      model: {
        value: (_vm.bulletPointsCollection.sourcing[index]),
        callback: function($$v) {
          _vm.$set(_vm.bulletPointsCollection.sourcing, index, $$v)
        },
        expression: "bulletPointsCollection.sourcing[index]"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "print"
    }, [_vm._v(_vm._s(bulletPoint))]), _vm._v(" "), _c('span', {
      staticClass: "monitor"
    }, [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.handleRemoveBulletPoint(index, 'sourcing')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-times"
    })])], 1), _vm._v(" "), _c('span', {
      staticClass: "clearfix"
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "monitor"
  }, [_c('el-form', {
    staticClass: "bullet-form",
    attrs: {
      "inline": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticClass: "bullet-edit",
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleAddBulletPoint('sourcing')
      }
    },
    model: {
      value: (_vm.newBulletPoint.sourcing),
      callback: function($$v) {
        _vm.$set(_vm.newBulletPoint, "sourcing", $$v)
      },
      expression: "newBulletPoint.sourcing"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddBulletPoint('sourcing')
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 sourcing"
  }, [_c('div', {
    staticClass: "monitor"
  }, [_c('label', [_vm._v("Extra notes / sourcing information:  ")]), _vm._v(" "), _c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "mini",
      "type": "primary",
      "icon": "el-icon-close"
    },
    on: {
      "click": function($event) {
        return _vm.toggleSaveNotes()
      }
    }
  }, [_vm._v(_vm._s(_vm.isEditSourcing ? 'Cancel' : 'Edit') + " Notes")]), _vm._v(" "), (_vm.isEditSourcing) ? _c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "mini",
      "type": "primary",
      "icon": "el-icon-check"
    },
    on: {
      "click": function($event) {
        return _vm.handleSaveSourceNotes(_vm.sourcing)
      }
    }
  }, [_vm._v("Save Notes")]) : _vm._e(), _vm._v(" "), (_vm.isEditSourcing) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 6
      }
    },
    model: {
      value: (_vm.sourcing),
      callback: function($$v) {
        _vm.sourcing = $$v
      },
      expression: "sourcing"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isEditSourcing) ? _c('div', {
    staticClass: "well well-sm"
  }, [_vm._v(_vm._s(_vm.sourcing))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 print"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatSourcing(_vm.sourcing))
    }
  })])])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.print()
      }
    }
  }, [_vm._v("Print")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f144e6f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveys/CategoryOneSheet.vue
// module id = 3169
// module chunks = 3